<template>
  <div>
    <ts-dialog title="Delivery checklist" :visible.sync="showChecklist" width="850px" center>
      <div class="list-actions">
        <div class="actions">
          <div class="platforms"></div>
        </div>
      </div>
      <div class="">
        <div class="checklist">
          <table class="">
            <tbody class="">
              <tr class="">
                <td class="">
                  <div class="cell-container left">
                    Make sure you have selected the broadcasting rights of your project
                  </div>
                </td>
                <td class="">
                  <div class="cell-container right">
                    <ts-button :type="broadcastingButtonClass" @click="applyBroadcastingRights" filled size="small"
                      >Broadcasting rights...</ts-button
                    >
                  </div>
                </td>
              </tr>
              <tr class="hide">
                <td class="">
                  <div class="cell-container left">
                    Do you have assets you want to upload on The Source ? Make sure to do so before sharing them
                  </div>
                </td>
                <td class="">
                  <div class="cell-container right">
                    <ts-button :type="publishButtonClass" filled size="small">Publish to The Source</ts-button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <span slot="footer">
        <ts-button
          @click="handleSharing"
          :loading="loading"
          :disabled="!canShareFinalAssets"
          filled
          :type="canShareFinalAssets ? 'primary' : 'normal'"
          >Share your final assets</ts-button
        >
      </span>
    </ts-dialog>
    <ts-dialog title="Share this page by link" :visible.sync="visible" width="550px" center>
      <p class="label">With this link, anyone can download the final assets you want to share.</p>
      <div class="flex items-center justify-center mb-4">
        <div class="row">
          <p class="font-semibold" v-text="url"></p>
        </div>
        <div class="actions">
          <ts-button size="small" circle @click="copy">
            <ts-icon icon="link" size="x-small" title="Copy" color="#6d7587" />
          </ts-button>
        </div>
      </div>
        <ts-form-item label="Add a specific comment to the page (optional) : " :validation="$v.form.description">
          <ts-input type="textarea" :rows="6" placeholder="" v-model.lazy="$v.form.description.$model"></ts-input>
        </ts-form-item>
      <div slot="footer" class="flex items-center justify-center">
        <div class="font-semibold" style="margin-right: 1rem;">
          <ts-button class="font-semibold" title="Close" @click="handleCloseButton">Close</ts-button>
        </div>
        <div class="font-semibold">
          <ts-button class="font-semibold" title="Share" filled type="primary" :loading="isSharing" @click="handleShareButton">Share</ts-button>
        </div>
      </div>
    </ts-dialog>
    <ts-button
      :loading="loading"
      title="Share"
      size="small"
      :type="canShareFinalAssets ? 'primary' : 'normal'"
      filled
      @click="handleOpenDialogButtonClick"
    >
      Share your final assets
    </ts-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import projectViewHelpers from '@/mixins/projectViewHelpers';
import { appId, config } from '@/api/workflow';

export default {
  mixins: [projectViewHelpers],
  props: {
    assets: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      showChecklist: false,
      isSharing: false,
      appUrl: null,
      form: {
        description: ''
      }
    };
  },
  computed: {
    ...mapState('workflow', {
      project: state => state.currentProject.value
    }),
    canShareFinalAssets() {
      return this.broadcastingRightsChecked;
    },
    platformsChecked() {
      return this.assets.every(asset => asset.platforms.length > 0);
    },
    broadcastingRightsChecked() {
      return this.project && this.project.broadcastingRights != null;
    },
    platformButtonClass() {
      return this.assets.every(asset => asset.platforms.length > 0) ? 'primary' : 'normal';
    },
    broadcastingButtonClass() {
      return this.project && this.project.broadcastingRights ? 'primary' : 'normal';
    },
    publishButtonClass() {
      return 'normal';
    },
    sharing() {
      return this.project.sharings.find(s => s.resource === 'delivery');
    },
    url() {
      return `${this.appUrl}/projects/sharings/${this.sharing?.token}`;
    }
  },
  validations: {
    form: {
      description: {}
    }
  },
  methods: {
    ...mapActions('workflow', ['shareProjectResource']),
    async copy() {
      try {
        await this.$copyText(this.url);
        this.showInfo('Link copied to clipboard');
      } catch (err) {
        console.error('Error when copying file request link', err);
        this.showError('Error when copying step link');
      }
    },
    async handleShareButton() {
      this.isSharing = true;
      this.shareFinalassets().then(() => {
        this.isSharing = false;
        this.copy()
      }).catch(err => this.isSharing = false);
    },
    applyBroadcastingRights() {
      this.visible = false;
      this.showChecklist = false;
      window.EventBus.$emit('Delivery.BroadcastingRights', () => {
        this.handleOpenDialogButtonClick();
      });
    },
    selectAssetsPlatform() {
      this.visible = false;
      this.showChecklist = false;
      window.EventBus.$emit('Delivery.PlatformSelection', () => {
        this.handleOpenDialogButtonClick();
      });
    },
    handleCloseButton() {
      this.visible = false;
    },
    handleOpenDialogButtonClick() {
      if (this.canShareFinalAssets) {
        this.handleSharing();
        return;
      }
      this.visible = false;
      this.showChecklist = true;
      return;
    },
    handleSharing() {
      this.loading = true;
      this.grabSharingLink().then(() => {
        this.loading = false;
        this.showChecklist = false;
        this.form.description = this.sharing.description;
        this.visible = true;
      });
    },
    async grabSharingLink() {
      if (!this.sharing) {
        this.shareFinalassets();
      }
    },
    async shareFinalassets() {
      return await this.shareProjectResource({
        projectId: this.project.id,
        resource: 'delivery',
        description: this.form.description,
        extras: {
          assets: this.assets.map(asset => asset.id)
        }
      });
    },
    resetForm() {
      this.form = {
        description: ''
      };

      this.$v.$reset();
    },
    skip() {
      this.visible = false;
      this.resetForm();
    },
    handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('input', this.form);
        this.visible = false;
        this.resetForm();
      }
    }
  },
  async mounted() {
    this.appUrl = config('auth.appUrl');
    window.EventBus.$on('Delivery.ShareFinalAssets', () => {
      this.handleOpenDialogButtonClick();
    });
  }
};
</script>

<style lang="scss" scoped>

.label{
  font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
    word-break: break-word;
    margin-bottom: .5rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.hide {
  display: none;
}
.checklist {
  table {
    width: 100%;
    tr {
      padding: 10px;
      &:nth-child(2n) {
        td {
          // border-top: 1px solid rgba(0, 0, 0, 0.1);
        }
      }
      td {
        .cell-container.right {
          text-align: center;
        }
        .cell-container.left {
          font-size: 1rem;
          color: #6d7587;
          word-break: break-word;
          white-space: normal;
          text-align: left;
        }
        .cell-container {
          padding: 16px;
        }
      }
    }
  }
}
.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;
  margin-right: 1rem;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .files {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}
.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5em;
}
.flex-1 {
  flex: auto;
}
.flex-none {
  flex: none;
}
.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.justify-between {
  justify-content: space-between;
}
.cursor-pointer {
  cursor: pointer;
}
</style>